import { addHocItem } from "@/api/other-addition-items";
import Dropdown, { Item } from "@/components/form/Dropdown";
import NumberInput from "@/components/form/NumberInput";
import { Button } from "@/components/ui/button";
import { toast } from "@/hooks/use-toast";
import {
  OtherAdditionItem,
  OtherAdditionItemType,
  OtherAdditionItemTypeLabels,
} from "@/models/other-addition-items.model";
import React, { useState } from "react";

interface Props {
  userId: number;
  month: number;
  year: number;
  payslipId?: number;
  updateOtherAdditionItems: (item: OtherAdditionItem) => void;
}

export const otherAdditionItemTypeArray: Item[] = Object.values(
  OtherAdditionItemType
).map((value) => ({
  value: value,
  label: OtherAdditionItemTypeLabels[value],
}));

function AddOtherAdditionForm({
  userId,
  month,
  year,
  payslipId,
  updateOtherAdditionItems,
}: Props) {
  const [type, setType] = useState<string>("");
  const [amount, setAmount] = useState<number>(0);
  const [err, setErr] = useState<string>("");
  const isValid = () => {
    if (type === "" || amount === 0) {
      setErr("Please fill all fields.");
      return false;
    }
    if (amount <= 0) {
      setErr("Amount must be greater than 0.");
      return false;
    }
    setErr("");
    return true;
  };

  const handleOtherAdditionItem = async () => {
    if (!isValid()) {
      return;
    }
    // Add other-addition item
    try {
      const otherAdditionItem = await addHocItem({
        amount,
        type: type as OtherAdditionItemType,
        userId,
        month,
        year,
        payslipId,
      });
      updateOtherAdditionItems(otherAdditionItem);
      if (otherAdditionItem) {
        toast({
          title: "Other addition item added",
          description: `Other addition item ${
            OtherAdditionItemTypeLabels[type as OtherAdditionItemType]
          } added successfully`,
        });
        setErr("");
        setType("");
        setAmount(0);
      }
    } catch (err) {
      console.error(err);
      toast({
        title: "Error",
        description: "Failed to add other-addition item",
        variant: "destructive",
      });
    }
  };
  return (
    <div className="flex gap-2 flex-col mt-3">
      <div className="flex gap-2 items-end">
        <Dropdown
          label="Type"
          items={otherAdditionItemTypeArray}
          selectedString={type}
          setSelectedString={setType}
        />
        <NumberInput
          label="Amount"
          value={amount}
          setValue={setAmount}
          placeholder="Amount"
        />
        <Button onClick={handleOtherAdditionItem} type="submit">
          Add
        </Button>
      </div>
      {err && <div className="text-red-500 text-sm">{err}</div>}
    </div>
  );
}

export default AddOtherAdditionForm;
